import * as React from 'react';
import { useDropzone } from 'react-dropzone';
import type { Accept } from 'react-dropzone';

import { color } from '@coursera/coursera-ui';
import { SvgCloudUpload } from '@coursera/coursera-ui/svg';

import _t from 'i18n!nls/enterprise-admin-users';

import 'css!./__styles__/FileUploadWidgetV2';

type Props = {
  onDrop: (x0: { files: Array<File> }) => void;
  defaultMessage?: string;
  singleFileOnly?: boolean;
  defaultFileMessage?: string;
  children?: React.ReactNode;
  accept?: Accept;
};

const FileUploadWidget: React.FC<Props> = ({
  defaultMessage = _t('browse files'),
  defaultFileMessage = _t('You can upload 1 file at a time'),
  singleFileOnly = false,
  accept,
  children,
  onDrop,
}) => {
  const instructions = singleFileOnly ? _t('Drop file here or ') : _t('Drop files here or ');
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (files: Array<File>) => {
      onDrop({ files });
    },
    accept,
  });
  return (
    <div className="rc-FileUploadWidgetV2 w-100 vertical-box">
      <div {...getRootProps({ className: 'c-uploadWrapper horizontal-box align-items-absolute-center p-a-2 w-100' })}>
        <input {...getInputProps()} data-testid="file-input" />
        <SvgCloudUpload color={color.primary} size={30} />
        <p className="m-b-0 c-uploadText m-l-1">
          {instructions}
          <span className="c-uploadLink m-b-0">{defaultMessage}</span>
          {singleFileOnly && <span className="c-upload-instructions">{defaultFileMessage}</span>}
        </p>
      </div>
      {children}
    </div>
  );
};

export default FileUploadWidget;
